import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppConfig } from 'app/app.config';
import { Region } from 'app/shared/models';

@Injectable()
export class RegionService {
  private regions: Region[];
  private regionApiUrl = this.config.getConfig('apiUrl') + '/v1/Regions';
  private headers = new HttpHeaders({
    'Content-Type': 'application/json',
    'Authorization-ApiKey': this.config.getConfig('apiKey')
  });

  constructor(private http: HttpClient, private config: AppConfig) {}

  public getRegions(): Promise<Region[]> {
    return this.regions
      ? Promise.resolve(this.regions)
      : this.http
          .get<Region[]>(this.regionApiUrl, { headers: this.headers })
          .toPromise()
          .then(response => {
            this.regions = response;
            return this.regions;
          })
          .catch(error => Promise.reject(error.message || error));
  }
}
